import { useEffect } from 'react'
import 'semantic-ui-css/semantic.min.css'
import {
  useFileUpload,
  useUppyPlugins,
  useUploadProgress,
  useLGUpload
} from '../hooks'
import LGVideoDisplay from './LG/LGVideoDisplay'
import UploadDashboard from './Upload/UploadDashboard'
import UploadProcessingModal from './UploadProcessingModal'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const UploadContainer = () => {
  const { uppy, API_GATEWAY_URL, createMultipartUpload } = useFileUpload()
  const location = useLocation()
  const navigate = useNavigate()

  const {
    shouldShowUploadDashboard,
    shouldShowLGVideo,
    handleBackToGallery,
    getUploadDashboardConfig
  } = useLGUpload()

  const { uploadProgress, ingestion, hideIngestion } = useUploadProgress(uppy)

  useUppyPlugins(uppy, API_GATEWAY_URL, createMultipartUpload)

  // Show message if redirected from gallery
  useEffect(() => {
    if (location.state?.redirectedFromGallery) {
      const toastId = 'redirected-from-gallery'
      if (!toast.isActive(toastId)) {
        toast.info(
          'You have no assets yet. Start uploading to see your assets in your organized gallery.',
          { autoClose: 5000, toastId }
        )
      }
      // Optionally clear the state so message doesn’t persist on reloads
      window.history.replaceState({}, document.title)
    }
  }, [location.state])

  const dashboardConfig = getUploadDashboardConfig()

  return (
    <>
      {/* Conditionally render the video if on LG Smart TV */}
      {shouldShowLGVideo() && (
        <LGVideoDisplay handleBackToGallery={handleBackToGallery} />
      )}

      {/* Conditionally render the dashboard if not on LG Smart TV */}
      {shouldShowUploadDashboard() && uppy && (
        <>
          <UploadDashboard uppy={uppy} dashboardConfig={dashboardConfig} />
          <UploadProcessingModal
            visible={ingestion.visible}
            stage={ingestion.stage || 'complete'}
            message={ingestion.message || ''}
            rotatingMessage={ingestion.rotatingMessage || ''}
            progress={0}
            totalFiles={uploadProgress.totalFiles}
            successfulFilesCount={uploadProgress.successfulFiles.length}
            failedFilesCount={uploadProgress.failedFiles.length}
            onClose={() => hideIngestion()}
            onGoToGallery={() => {
              hideIngestion()
              navigate('/gallery')
            }}
          />
        </>
      )}
    </>
  )
}

export default UploadContainer
